import { useSelector, useDispatch } from 'react-redux';
import useSelectedContactId from './useSelectedContactId';

const useSelectedContact = () => {
  const selectedContactId = useSelectedContactId();
  const dispatch = useDispatch();
  const selectedContact = useSelector(({ chatContacts }) =>
    !chatContacts ? null : chatContacts.find(contact => contact.id === selectedContactId),
  );

  return {
    selectedContact,
    loadSelectedContact: () => dispatch.chatContacts.loadSelectedContact(selectedContactId),
  };
};

export default useSelectedContact;
